import { Route, Routes as RRoutes } from "react-router-dom";
import ChatWindow from "./pages/ChatWindow";
import CreateChat from "./pages/CreateChat";
import AddParticipant from "./pages/AddParticipant";
import Home from "./pages/Home";

const Routes = () => {
  return (
    <RRoutes>
      <Route path="/" element={<ChatWindow />} />
      <Route path="create-chat" element={<CreateChat />} />
      <Route path="add-participant" element={<AddParticipant />} />
      <Route path="/dev" element={<Home />} />
    </RRoutes>
  );
};

export default Routes;
